(function () {
    'use strict';

    function escapeHtml(text) {
        if (!text) return '';
        return text.toString()
            .replace(/&/g, "&amp;")
            .replace(/</g, "&lt;")
            .replace(/>/g, "&gt;")
            .replace(/"/g, "&quot;");
    }

    function initLocationSearchForm(form) {
        const input = form.querySelector('.js-location-input');
        const resultsBox = form.querySelector('.js-location-results');
        const tagBox = form.querySelector('.js-location-tag');
        const wrap = form.querySelector('.js-location-wrap');

        const hCity = form.querySelector('.js-city-id');
        const hDistrict = form.querySelector('.js-district-id');
        const hQuarter = form.querySelector('.js-quarter-id');
        const hLocationLabel = form.querySelector('.js-location-label');

        const searchUrl = form.dataset.locationSearchUrl;

        if (!form || !input || !resultsBox || !searchUrl) return;

        let debounceTimer = null;
        let currentFocus = -1;

        function closeResults() {
            resultsBox.style.display = 'none';
            currentFocus = -1;
        }

        function resetHiddenInputs() {
            if (hCity) {
                hCity.value = '';
                hCity.disabled = true;
            }

            if (hDistrict) {
                hDistrict.value = '';
                hDistrict.disabled = true;
            }

            if (hQuarter) {
                hQuarter.value = '';
                hQuarter.disabled = true;
            }

            if (hLocationLabel) {
                hLocationLabel.value = '';
                hLocationLabel.disabled = true;
            }
        }

        function hasSelectedLocation() {
            return !!(
                (hCity && hCity.value) ||
                (hDistrict && hDistrict.value) ||
                (hQuarter && hQuarter.value)
            );
        }

        function createTag(text) {
            if (!tagBox) return;

            tagBox.innerHTML = `
                <i class="ph-fill ph-map-pin"></i>
                <span>${escapeHtml(text)}</span>
                <div class="remove-tag" title="Kaldır">
                    <i class="ph-bold ph-x"></i>
                </div>
            `;

            tagBox.style.display = 'flex';
            wrap.classList.add('has-tag');

            requestAnimationFrame(() => {
                const tagWidth = tagBox.offsetWidth;
                input.style.paddingLeft = (tagWidth + 20) + 'px';
            });

            const removeBtn = tagBox.querySelector('.remove-tag');
            if (removeBtn) {
                removeBtn.addEventListener('click', function (e) {
                    e.preventDefault();
                    e.stopPropagation();
                    resetSelection(true);
                    input.focus();
                });
            }
        }

        function resetSelection(clearInput = false) {
            resetHiddenInputs();

            if (clearInput) {
                input.value = '';
            }

            input.style.paddingLeft = '';
            wrap.classList.remove('has-tag');

            if (tagBox) {
                tagBox.style.display = 'none';
                tagBox.innerHTML = '';
            }
        }

        function selectItem(item) {
            const type = item.dataset.type;
            const id = item.dataset.id;
            const label = item.dataset.label;

            resetHiddenInputs();

            if (type === 'city' && hCity) {
                hCity.value = id;
                hCity.disabled = false;
            } else if (type === 'district' && hDistrict) {
                hDistrict.value = id;
                hDistrict.disabled = false;
            } else if (type === 'neighborhood' && hQuarter) {
                hQuarter.value = id;
                hQuarter.disabled = false;
            }

            if (hLocationLabel) {
                hLocationLabel.value = label;
                hLocationLabel.disabled = false;
            }

            input.value = '';
            createTag(label);
            closeResults();
        }

        async function fetchResults(query) {
            try {
                const url = new URL(searchUrl, window.location.origin);
                url.searchParams.set('q', query);

                const response = await fetch(url, {
                    headers: {
                        'X-Requested-With': 'XMLHttpRequest',
                        'Accept': 'application/json'
                    }
                });

                const data = await response.json();
                renderResults(data.items || []);
            } catch (err) {
                console.error('Header location search error:', err);
                closeResults();
            }
        }

        function renderResults(items) {
            if (!items.length) {
                resultsBox.innerHTML = `<div class="ac-no-result">Sonuç bulunamadı.</div>`;
                resultsBox.style.display = 'block';
                return;
            }

            resultsBox.innerHTML = items.map(item => `
                <div class="ac-item"
                     data-type="${escapeHtml(item.type)}"
                     data-id="${escapeHtml(item.id)}"
                     data-label="${escapeHtml(item.label)}">
                    <div class="ac-icon">
                        <i class="ph-light ${escapeHtml(item.icon)}"></i>
                    </div>
                    <div class="ac-info">
                        <span class="ac-label">${escapeHtml(item.label)}</span>
                        ${item.sub ? `<span class="ac-sub">${escapeHtml(item.sub)}</span>` : ''}
                    </div>
                </div>
            `).join('');

            resultsBox.style.display = 'block';
            currentFocus = -1;

            resultsBox.querySelectorAll('.ac-item').forEach(el => {
                el.addEventListener('click', function () {
                    selectItem(this);
                });
            });
        }

        function removeActive(items) {
            items.forEach(i => i.classList.remove('ac-active'));
        }

        function addActive(items) {
            if (!items.length) return;

            removeActive(items);

            if (currentFocus >= items.length) currentFocus = 0;
            if (currentFocus < 0) currentFocus = items.length - 1;

            items[currentFocus].classList.add('ac-active');
            items[currentFocus].scrollIntoView({ block: 'nearest' });
        }

        input.addEventListener('input', function () {
            const val = this.value.trim();

            if (hasSelectedLocation()) {
                resetSelection(false);
            }

            if (val.length < 2) {
                closeResults();
                return;
            }

            clearTimeout(debounceTimer);
            debounceTimer = setTimeout(() => fetchResults(val), 250);
        });

        input.addEventListener('keydown', function (e) {
            const items = Array.from(resultsBox.querySelectorAll('.ac-item'));

            if (e.key === 'ArrowDown') {
                e.preventDefault();
                currentFocus++;
                addActive(items);
                return;
            }

            if (e.key === 'ArrowUp') {
                e.preventDefault();
                currentFocus--;
                addActive(items);
                return;
            }

            if (e.key === 'Enter') {
                if (resultsBox.style.display !== 'none' && items.length > 0) {
                    e.preventDefault();

                    if (currentFocus > -1) {
                        items[currentFocus].click();
                    } else {
                        items[0].click();
                    }
                }
            }

            if (e.key === 'Backspace' && input.value === '' && hasSelectedLocation()) {
                resetSelection(true);
            }
        });

        form.addEventListener('submit', function (e) {
            const keyword = input.value.trim();
            const hasLocation = hasSelectedLocation();

            if (!keyword && !hasLocation) {
                e.preventDefault();
                input.focus();
                return;
            }

            // Lokasyon seçildiyse q boş gitsin
            if (hasLocation) {
                input.value = '';
            }
        });

        document.addEventListener('click', function (e) {
            if (!form.contains(e.target)) {
                closeResults();
            }
        });

        // İlk yüklemede request'ten gelen lokasyon tag'ini geri bas
        if (hasSelectedLocation() && hLocationLabel && hLocationLabel.value) {
            createTag(hLocationLabel.value);
            input.value = '';
        }
    }

    function initAll() {
        document.querySelectorAll('.js-location-search-form').forEach(initLocationSearchForm);
    }

    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', initAll, { once: true });
    } else {
        initAll();
    }
})();
